module.exports = __webpack_public_path__ + "assets/b9ba3c79768dedf997495232b61f582f.png";